import {
  FETCH_FEEDBACK_LIST,
  FETCH_FEEDBACK_LIST_FAILURE,
  FETCH_FEEDBACK_LIST_SUCCESS,
  //
  SUBMIT_FEEDBACK,
  SUBMIT_FEEDBACK_FAILURE,
  SUBMIT_FEEDBACK_SUCCESS,
  //
  UPDATE_FEEDBACK,
  UPDATE_FEEDBACK_FAILURE,
  UPDATE_FEEDBACK_SUCCESS,
  //
  UPDATE_FEEDBACK_STATUS,
  UPDATE_FEEDBACK_STATUS_FAILURE,
  UPDATE_FEEDBACK_STATUS_SUCCESS,
} from "./constants";

// Submit
export const submitFeedback = (payload, onDone) => ({
  type: SUBMIT_FEEDBACK,
  payload,
  onDone,
});
export const submitFeedbackSuccess = (payload) => ({
  type: SUBMIT_FEEDBACK_SUCCESS,
  payload,
});
export const submitFeedbackFailure = (payload) => ({
  type: SUBMIT_FEEDBACK_FAILURE,
  payload,
});

// List
export const fetchFeedbackList = (payload) => ({
  type: FETCH_FEEDBACK_LIST,
  payload,
});
export const fetchFeedbackListSuccess = (payload) => ({
  type: FETCH_FEEDBACK_LIST_SUCCESS,
  payload,
});
export const fetchFeedbackListFailure = (payload) => ({
  type: FETCH_FEEDBACK_LIST_FAILURE,
  payload,
});

// Update (submitter self-edit)
export const updateFeedback = (payload, onDone) => ({
  type: UPDATE_FEEDBACK,
  payload,
  onDone,
});
export const updateFeedbackSuccess = (payload) => ({
  type: UPDATE_FEEDBACK_SUCCESS,
  payload,
});
export const updateFeedbackFailure = (payload) => ({
  type: UPDATE_FEEDBACK_FAILURE,
  payload,
});

// Update status (product-team triage)
export const updateFeedbackStatus = (payload, onDone) => ({
  type: UPDATE_FEEDBACK_STATUS,
  payload,
  onDone,
});
export const updateFeedbackStatusSuccess = (payload) => ({
  type: UPDATE_FEEDBACK_STATUS_SUCCESS,
  payload,
});
export const updateFeedbackStatusFailure = (payload) => ({
  type: UPDATE_FEEDBACK_STATUS_FAILURE,
  payload,
});
